import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation createMagnetTimeout($model: MagnetTimeoutInput) {
  createMagnetTimeout(magnetTimeout: $model) {
    id
    magnetTimeout
    team {
      id
      name
    }
    channel {
      id
      name
    }
    requestType {
      id
      name
    }  
  }
}`;

const fieldsName = {
  message: 'T_MAGNET_TIMEOUT',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function createMagnet(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createMagnetTimeout)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default createMagnet;
